<section class="left">
	<go-logo></go-logo>

	<div class="small-logo hide-screen-md-min hide-screen-sm">
		<img src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg" alt="GoReact"> <span translate="{{titleString}}"></span>
	</div>

	<p class="description" translate="email-and-password_description"></p>

	<img class="left-image" src="https://staticassets.goreact.com/sign-up.png" alt="{{'email-and-password_video-feedback' | translate}}">

</section>

<section class="right" [formGroup]="form" #content>
	<div class="sign-in-wrapper hide-screen-sm"><span translate="sign-up-already-have-an-account"></span> <button type="button" class="login-link goreact-btn tertiary-btn color-red" (click)="navigateToLogin()" translate="log-in"></button></div>

	<h1 class="hide-screen-sm" translate="{{titleString}}"></h1>
	<div class="small-logo hide-tablet-min">
		<img src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg" alt="GoReact"> <span translate="{{titleString}}"></span>
	</div>

	<div class="name-fields">
		<mat-form-field appearance="outline" *ngIf="form.controls.firstName">
			<mat-label>{{'sign-up-form-label-first-name' | translate}}</mat-label>
			<input type="text" matInput formControlName="firstName" data-cy="guest-signup-form-first-name" class="fullstory-ignore" />
			<mat-error *ngIf="form.controls.firstName.hasError('required')">{{'sign-up-form-validation-first-name-required' | translate}}</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline" *ngIf="form.controls.lastName">
			<mat-label>{{'sign-up-form-label-last_name' | translate}}</mat-label>
			<input type="text" matInput formControlName="lastName" data-cy="guest-signup-form-last-name" class="fullstory-ignore" />
			<mat-error *ngIf="form.controls.lastName.hasError('required')">{{'sign-up-form-validation-last-name-required' | translate}}</mat-error>
		</mat-form-field>
	</div>

	<mat-form-field appearance="outline" class="email-form-field-container">
		<mat-label>{{'common_email' | translate}}</mat-label>
		<input type="email" matInput formControlName="email" maxlength="100" data-cy="ins-signup-form-email" class="fullstory-ignore" [readonly]="lockEmailField"/>
		<mat-icon
			*ngIf="mode !== SIGNUPMODES.GUEST_REVIEW"
			matSuffix
			class="ficon-app-help-circle-outline"
			[goTooltip]="'sign-up-recommend-work-email' | translate"
			goTooltipPlacement="top|right"
		></mat-icon>
		<mat-error *ngIf="form.controls.email.hasError('email')" data-cy="ins-signup-form-email-invalid">{{'sign-up-form-validation-email-invalid' | translate}}</mat-error>
		<mat-error *ngIf="form.controls.email.hasError('required')">{{'sign-up-form-validation-email-required' | translate}}</mat-error>
	</mat-form-field>

	<mat-form-field appearance="outline" class="password-form-field-container" goPasswordVisibilityToggle goPasswordRequirements>
		<mat-label>{{'sign-up-form-label-password' | translate}}</mat-label>
		<input type="password" matInput formControlName="password" data-cy="ins-signup-form-password" class="fullstory-ignore password-form-field" />
		<mat-icon
				matSuffix
				class="ficon-app-help-circle-outline"
				[goTooltip]="'sign-up-password-rules' | translate"
				goTooltipPlacement="top|right"
		></mat-icon>
		<mat-error *ngIf="form.controls.password.invalid" data-cy="ins-signup-form-password-invalid">{{'common_password_error-password-requirements' | translate}}</mat-error>
	</mat-form-field>
	<span class="terms-and-privacy" [innerHTML]="
		'terms-privacy-with-links-signup' | translate:{
			terms: 'https://get.goreact.com/terms',
			privacy: 'https://get.goreact.com/privacy'
		}">
	</span>

	<div role="alert" class="http-error" *ngIf="httpError">{{httpError}}</div>

	<div class="signup-options-wrapper">
		<button
			class="submit-btn primary-btn"
			data-cy="ins-signup-form-submit-btn"
			(click)="submit()"
			[disabled]="loading"
			[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">{{(loading ? 'common_please-wait_loading' : 'sign-up') | translate}}
		</button>

		<sso-provider-button (onLoginWithSso)="signupWithSso($event)"></sso-provider-button>
	</div>

	<div class="sign-in-wrapper hide-tablet-min"><span translate="sign-up-already-have-an-account"></span> <button type="button" class="login-link goreact-btn tertiary-btn color-red" (click)="navigateToLogin()" translate="log-in"></button></div>

	<div class="user-type-info" *ngIf="mode !== SIGNUPMODES.GUEST_REVIEW">
		<div [innerHTML]="'email-and-password_student-and-student-teachers' | translate"></div>
		<span>
			<mat-icon
					matSuffix
					class="ficon-app-help-circle-outline"
					[goTooltip]="'sign-up-student-student-teachers' | translate"
					goTooltipPlacement="top|right"
			></mat-icon>
		</span>
	</div>
</section>
